export const validateEmail = (email) => {
    try {
        if (email.length > 255) {
            throw new Error("Email exceeds the maximum allowed length of 255 characters.");
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    } catch (error) {
        console.error("Error validating email:", error.message);
        return false;
    }
};
